export default __webpack_public_path__ + "static/media/bubble_bg.873e8daa.png";